import type { ComponentProps } from "react";

type Props = ComponentProps<"p"> & {
  text: string | null;
};

export default function ErrorMessage({ className = "", text, ...rest }: Props) {
  return text ? (
    <p className={`kup-error-message inline-block ${className}`} {...rest}>
      {text}
    </p>
  ) : null;
}
